import { useState, useEffect, useCallback } from "react";
import { listPresets, createPreset, deletePreset } from "@/lib/decartApi";
import { toast } from "sonner";
import { logWarn } from "@/lib/log";

export function useSavedPresets() {
    const [savedPresets, setSavedPresets] = useState([]);

    useEffect(() => {
        listPresets()
            .then(setSavedPresets)
            .catch((e) => logWarn("[SPCLIVE] preset load failed", e));
    }, []);

    const saveStyle = useCallback(async (label, prompt) => {
        const created = await createPreset(label, prompt);
        setSavedPresets((prev) => [created, ...prev]);
        toast.success(`Style "${created.label}" saved`);
        return created;
    }, []);

    const removeStyle = useCallback(async (id) => {
        await deletePreset(id);
        setSavedPresets((prev) => prev.filter((p) => p.id !== id));
        toast.info("Saved style removed");
    }, []);

    return { savedPresets, saveStyle, removeStyle };
}
